// src/components/NotificationHandler.js

import React, { useState, useEffect } from 'react';
import { onForegroundMessage } from '../services/pushService';
import NotificationBanner from './NotificationBanner';

const NotificationHandler = () => {
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    console.log('Setting up notification handler');
    let unsubscribe = null;
    let isActive = true;

    (async () => {
      try {
        const nextUnsubscribe = await onForegroundMessage((payload) => {
          console.log('Handling new notification:', payload);
          const { data } = payload;
          const messageData = data || {};
          setNotification({
            title: messageData.title,
            body: messageData.body,
            type: messageData.type,
            groupId: messageData.groupId,
            relatedId: messageData.relatedId,
            commentIndex: messageData.commentIndex,
            replyIndex: messageData.replyIndex,
            commentId: messageData.commentId,
            threadRootId: messageData.threadRootId,
            url: messageData.url,
            notificationId: messageData.notificationId,
          });
        });
        if (!isActive) {
          if (nextUnsubscribe && typeof nextUnsubscribe === 'function') {
            nextUnsubscribe();
          }
          return;
        }
        unsubscribe = nextUnsubscribe;
      } catch (error) {
        console.error('Error setting up message listener:', error);
      }
    })();

    return () => {
      console.log('Cleaning up notification handler');
      isActive = false;
      if (unsubscribe && typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  const handleDismiss = () => {
    setNotification(null);
  };

  if (!notification) return null;

  return (
    <NotificationBanner 
      notification={notification} 
      onDismiss={handleDismiss}
    />
  );
};

export default NotificationHandler;
